export const hideCreditsOverCookieName = 'hideCreditsOverWarning'
